<template>
  <div class="hc-cards" data-testid="hc-cards-root" :style="gridStyle">
    <component
      :is="item.link ? 'a' : 'div'"
      v-for="(item, index) in items"
      :key="index"
      class="hc-cards__item"
      :href="item.link || null"
      :target="item.newTab ? '_blank' : null"
      :rel="item.newTab ? 'noopener noreferrer' : null"
      :data-testid="`hc-cards-item-${index}`"
    >
      <img
        v-if="item.image"
        class="hc-cards__image"
        :src="item.image"
        :alt="item.title"
        loading="lazy"
      />
      <img
        v-else-if="item.icon"
        class="hc-cards__icon"
        :src="item.icon"
        :alt="item.title"
        loading="lazy"
      />
      <h3 v-if="item.title" class="hc-cards__title">{{ item.title }}</h3>
      <p v-if="item.subtitle" class="hc-cards__subtitle">{{ item.subtitle }}</p>
      <p v-if="item.description" class="hc-cards__description">
        {{ item.description }}
      </p>
    </component>
  </div>
</template>

<script>
import { safeUrl } from '../../blockConfig';

// Presentational grid of cards, shared by the Cards and Grid block types (Grid
// is Cards with a denser default column count — mirrors the legacy ERB
// partials, where _dynamic_grid.html.erb rendered _dynamic_cards.html.erb).
const MIN_COLUMNS = 1;
const MAX_COLUMNS = 6;

export default {
  name: 'CardsBlock',
  props: {
    config: { type: Object, default: () => ({}) },
  },
  computed: {
    items() {
      const items = this.config && this.config.items;
      if (!Array.isArray(items)) return [];
      return items.map(item => ({
        image: safeUrl(item.image),
        icon: safeUrl(item.icon),
        title: item.title || '',
        subtitle: item.subtitle || '',
        description: item.description || '',
        link: safeUrl(item.link),
        newTab: !!item.newTab,
      }));
    },
    columns() {
      const columns = Number(this.config.columns);
      if (!Number.isFinite(columns)) return 3;
      return Math.min(Math.max(Math.round(columns), MIN_COLUMNS), MAX_COLUMNS);
    },
    gridStyle() {
      return { '--hc-cards-columns': this.columns };
    },
  },
};
</script>

<style src="./styles/CardsBlock.scss" lang="scss" scoped></style>
